import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { AuthService } from '@/api/models/auth'
import { USER_QUERY_KEY } from '@/api/models/common/hooks/useUser'

import {
  getPremisesWithoutGuestParking,
  getPremisesWithoutParkingPlaces
} from '../lib/main.utils'

export const PROJECT_LIST_RQ_KEY = 'projects'

export const useProjectList = () => {
  const { status, data, error, isLoading, isFetching } = useQuery({
    queryKey: [USER_QUERY_KEY],
    queryFn: () => AuthService.getCurrentUser(),
    placeholderData: keepPreviousData,
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnMount: false,
    refetchOnWindowFocus: false
  })

  const dataWithoutGuestParking = useMemo(
    () =>
      data?.projects.map(project => ({
        ...project,
        premises: getPremisesWithoutGuestParking(project.premises)
      })),
    [data?.projects]
  )

  const dataWithoutParkingPlaces = useMemo(
    () =>
      data?.projects.map(project => ({
        ...project,
        allPremises: getPremisesWithoutParkingPlaces(project.allPremises),
        premises: getPremisesWithoutParkingPlaces(project.premises)
      })),
    [data?.projects]
  )

  return {
    data: data?.projects,
    dataWithoutGuestParking,
    dataWithoutParkingPlaces,
    error,
    isLoading,
    isFetching,
    status
  }
}
